import React from 'react';
import { Instagram, Linkedin, Camera } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-400 py-12 border-t border-gray-800" data-id="element-54">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-56">
          <div className="flex items-center mb-6 md:mb-0" data-id="element-57">
            <Camera className="h-6 w-6 text-[#D4A574] mr-2" data-id="element-58" />
            <span className="text-lg font-bold text-white" data-id="element-59">Julia Pfeifer</span>
          </div>

          <div className="flex space-x-6 mb-6 md:mb-0" data-id="element-60">
            <a href="#" className="hover:text-[#D4A574] transition-colors" data-id="element-61">
              Impressum
            </a>
            <a href="#" className="hover:text-[#D4A574] transition-colors" data-id="element-62">
              Datenschutz
            </a>
            <a href="#" className="hover:text-[#D4A574] transition-colors" data-id="element-63">
              AGB
            </a>
          </div>

          <div className="flex space-x-4" data-id="element-64">
            <a href="#" className="h-10 w-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#D4A574] hover:text-white transition-colors" aria-label="Instagram" data-id="element-65">
              <Instagram className="h-5 w-5" data-id="element-66" />
            </a>
            <a href="#" className="h-10 w-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#D4A574] hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-67">
              <Linkedin className="h-5 w-5" data-id="element-68" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-sm" data-id="element-69">
          <p data-id="element-70">
            &copy; {new Date().getFullYear()} Julia Pfeifer Fotografie. Alle
            Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>;
}